import api, { ResponseCallback } from '../services/api.service'
import { InventoryData } from './inventory.api'

type ReceivingData = InventoryData

export interface ReceivingCreateRequest {
  interShip?: boolean
  purchaseOrder?: number
  item?: number
  quantity?: number
  pallet?: number
  reference?: string
  sku?: string
  productId?: string
  batchLotNumber?: string
  billOfLading?: string
  notes?: string
  latitude?: number
  longitude?: number
}

const routes = {
  create: '/receivings'
}

export default {
  create (
    payload: ReceivingCreateRequest,
    callback: ResponseCallback<ReceivingData>
  ) {
    api.post(routes.create, payload, callback)
  }
}
